import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Eye, Layers, Shield, Target } from 'lucide-react';
export function RulesSection() {
  return <section className="w-full px-4 md:px-6" data-id="element-228">
      <div className="max-w-3xl mx-auto" data-id="element-229">
        <FadeIn className="mb-16 text-center" data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white" data-id="element-231">
            La solución real:{' '}
            <span className="text-brand-gold" data-id="element-232">Reglas del Dinero</span>
          </h2>
          <p className="text-lg text-brand-muted" data-id="element-233">
            Este manual te enseña un sistema simple y ejecutable para construir
            control.
          </p>
        </FadeIn>

        <div className="space-y-12" data-id="element-234">
          {/* Rule 1 */}
          <FadeIn className="relative pl-8 md:pl-12 border-l border-brand-gold/30" data-id="element-235">
            <div className="absolute -left-3 top-0 bg-brand-bg border border-brand-gold text-brand-gold w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-id="element-236">
              1
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-237">
              Claridad absoluta
            </h3>
            <div className="flex flex-col md:flex-row gap-6" data-id="element-238">
              <div className="flex-1" data-id="element-239">
                <p className="text-brand-text mb-4" data-id="element-240">Saber exactamente:</p>
                <ul className="space-y-2 mb-4" data-id="element-241">
                  <li className="flex items-center gap-2 text-brand-muted" data-id="element-242">
                    <Eye className="w-4 h-4 text-brand-gold" data-id="element-243" /> Cuánto tienes
                  </li>
                  <li className="flex items-center gap-2 text-brand-muted" data-id="element-244">
                    <Eye className="w-4 h-4 text-brand-gold" data-id="element-245" /> Dónde está
                  </li>
                  <li className="flex items-center gap-2 text-brand-muted" data-id="element-246">
                    <Eye className="w-4 h-4 text-brand-gold" data-id="element-247" /> Para qué sirve
                  </li>
                </ul>
                <p className="text-brand-text italic" data-id="element-248">
                  Sin claridad, tu cerebro inventa historias. Y las historias
                  cuestan dinero.
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Rule 2 */}
          <FadeIn className="relative pl-8 md:pl-12 border-l border-brand-gold/30" data-id="element-249">
            <div className="absolute -left-3 top-0 bg-brand-bg border border-brand-gold text-brand-gold w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-id="element-250">
              2
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-251">
              Separación estratégica
            </h3>
            <p className="text-brand-text mb-6" data-id="element-252">
              Tu dinero se divide por función, no por emoción.
            </p>

            <div className="bg-brand-card p-6 rounded-lg border border-brand-bg" data-id="element-253">
              <h4 className="text-sm uppercase tracking-wider text-brand-muted font-bold mb-4" data-id="element-254">
                Las 4 funciones del dinero:
              </h4>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-255">
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-256">
                  <span className="text-brand-gold font-bold" data-id="element-257">1</span>
                  <span className="text-white" data-id="element-258">Supervivencia</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-259">
                  <span className="text-brand-gold font-bold" data-id="element-260">2</span>
                  <span className="text-white" data-id="element-261">Estabilidad</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-262">
                  <span className="text-brand-gold font-bold" data-id="element-263">3</span>
                  <span className="text-white" data-id="element-264">Crecimiento</span>
                </div>
                <div className="flex items-center gap-3 p-3 bg-brand-bg/50 rounded border border-brand-bg/50" data-id="element-265">
                  <span className="text-brand-gold font-bold" data-id="element-266">4</span>
                  <span className="text-white" data-id="element-267">Multiplicación</span>
                </div>
              </div>
              <p className="mt-4 text-center text-brand-gold font-serif italic" data-id="element-268">
                "Sin estabilidad, la multiplicación es fantasía."
              </p>
            </div>
          </FadeIn>

          {/* Rule 3 */}
          <FadeIn className="relative pl-8 md:pl-12 border-l border-brand-gold/30" data-id="element-269">
            <div className="absolute -left-3 top-0 bg-brand-bg border border-brand-gold text-brand-gold w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold" data-id="element-270">
              3
            </div>
            <h3 className="text-2xl font-bold text-white mb-4" data-id="element-271">
              Rol definido antes de moverlo
            </h3>
            <p className="text-brand-text mb-4" data-id="element-272">
              Antes de gastar o invertir, decides:
            </p>
            <ul className="space-y-2 mb-4 bg-brand-card/30 p-4 rounded border-l-2 border-brand-gold" data-id="element-273">
              <li className="text-brand-text" data-id="element-274">
                ¿Este dinero puede asumir riesgo?
              </li>
              <li className="text-brand-text" data-id="element-275">¿Qué pasa si sale mal?</li>
              <li className="text-brand-text" data-id="element-276">¿Cuál es el límite?</li>
            </ul>
            <p className="text-brand-text" data-id="element-277">
              Esto corta el impulso. Y el impulso, en finanzas, es caro.
            </p>
          </FadeIn>

          {/* Implementation - 4 Accounts */}
          <FadeIn className="mt-20 pt-12 border-t border-brand-card" data-id="element-278">
            <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-279">
              “Ok… pero ¿cómo lo ejecuto en la vida real?”
            </h3>
            <p className="text-center text-brand-muted mb-10" data-id="element-280">
              Con murallas. El manual te da el mapa práctico de{' '}
              <strong className="text-white" data-id="element-281">4 cuentas esenciales</strong>:
            </p>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-282">
              {[{
              name: 'Personal',
              icon: <Target className="w-6 h-6" data-id="element-283" />
            }, {
              name: 'Operativa',
              sub: '(Negocio)',
              icon: <Layers className="w-6 h-6" data-id="element-284" />
            }, {
              name: 'Protección',
              icon: <Shield className="w-6 h-6" data-id="element-285" />
            }, {
              name: 'Inversión',
              icon: <Activity className="w-6 h-6" data-id="element-286" />
            }].map((acc, i) => <div key={i} className="flex flex-col items-center justify-center p-6 bg-brand-card rounded-lg border border-brand-gold/10 hover:border-brand-gold/50 transition-colors text-center h-32" data-id="element-287">
                  <div className="text-brand-gold mb-3" data-id="element-288">{acc.icon}</div>
                  <span className="font-bold text-white" data-id="element-289">{acc.name}</span>
                  {acc.sub && <span className="text-xs text-brand-muted mt-1" data-id="element-290">
                      {acc.sub}
                    </span>}
                </div>)}
            </div>
            <p className="text-center text-brand-muted mt-8 text-sm" data-id="element-291">
              No para complicarte. Para que un golpe no te destruya todo.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}
// Helper icon component since Activity wasn't imported above but used
function Activity(props: any) {
  return <svg {...props} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-292">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2" data-id="element-293" />
    </svg>;
}